export class ContentLogo {
  mainLogo: string;
  mainLogoUrl: string;
  mainLogoAltText: string;
  mainLogoNewTab: string;
  busiLogo: string;
  busiLogoUrl: string;
  busiLogoAltText: string;
  busiLogoNewTab: string;
  subLogo: string;
  subLogoUrl: string;
  subLogoAltText: string;
  subLogoExtLinkPopup: string;
  subLogoNewTab: string;
  slimheaderLogo: string;
  slimheaderLogoUrl: string;
  slimheaderLogoAltText: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['mainLogo']) {
        this.mainLogo = contentjson['mainLogo'];
      }
      if (contentjson['mainLogoUrl']) {
        this.mainLogoUrl = contentjson['mainLogoUrl'];
      }
      if (contentjson['mainLogoAltText']) {
        this.mainLogoAltText = contentjson['mainLogoAltText'];
      }
      if (contentjson['mainLogoNewTab']) {
        this.mainLogoNewTab = contentjson['mainLogoNewTab'];
      }
      if (contentjson['busiLogo']) {
        this.busiLogo = contentjson['busiLogo'];
      }
      if (contentjson['busiLogoUrl']) {
        this.busiLogoUrl = contentjson['busiLogoUrl'];
      }
      if (contentjson['busiLogoAltText']) {
        this.busiLogoAltText = contentjson['busiLogoAltText'];
      }
      if (contentjson['busiLogoNewTab']) {
        this.busiLogoNewTab = contentjson['busiLogoNewTab'];
      }
      if (contentjson['subLogo']) {
        this.subLogo = contentjson['subLogo'];
      }
      if (contentjson['subLogoUrl']) {
        this.subLogoUrl = contentjson['subLogoUrl'];
      }
      if (contentjson['subLogoAltText']) {
        this.subLogoAltText = contentjson['subLogoAltText'];
      }
      if (contentjson['subLogoExtLinkPopup']) {
        this.subLogoExtLinkPopup = contentjson['subLogoExtLinkPopup'];
      }
      if (contentjson['subLogoNewTab']) {
        this.subLogoNewTab = contentjson['subLogoNewTab'];
      }
      if (contentjson['slimheaderLogo']) {
        this.slimheaderLogo = contentjson['slimheaderLogo'];
      }
      if (contentjson['slimheaderLogoUrl']) {
        this.slimheaderLogoUrl = contentjson['slimheaderLogoUrl'];
      }
      if (contentjson['slimheaderLogoAltText']) {
        this.slimheaderLogoAltText = contentjson['slimheaderLogoAltText'];
      }
    }
  }
}
